import React from 'react';
import { Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';
import FormDeposito from '../../admGeneral/depositos/formDeposito';

import getDepositoPorId from '../../../graphql/querys/ventas/getDepositoPorId.graphql';
import updateDepositoPorId from '../../../graphql/mutations/venta/updateDepositoPorId.graphql';
import getDepositos from '../../../graphql/querys/ventas/getDepositos.graphql';
import { errorService } from '../../../graphql/utils/utils';

@compose(
  graphql(updateDepositoPorId, {
    name: 'updateDepositoPorId',
    options: {
      refetchQueries: [{ query: getDepositos }],
    },
  })
)
class EditarDeposito extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      persona: {},
      deposito: {},
      id_TipoCertificacion: '',
      cantidad: 0,
      step: 0,
      guardado: false,
      loading: true,
    };

    this.props.client
      .query({
        query: getDepositoPorId,
        variables: { _id: this.props.match.params.id },
      })
      .then(res => {
        const deposito = res.data.getDepositoPorId;

        this.setState({
          loading: false,
          deposito: deposito,
        });
      })
      .catch(err => {
        console.log('Error en la creacion');
        console.log(err);
        errorService(err, {
          _id: this.props.match.params.id,
        });
        Modal.error({
          title: 'Error en la inicializacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  }

  actualizarDeposito = deposito => {
    this.props
      .updateDepositoPorId({
        variables: { _id: this.props.match.params.id, nuevoDeposito: deposito },
      })
      .then(res => {
        if (res.data.updateDepositoPorId._id) {
          notification.success({
            message: 'Actualizacion Correcta',
            description: 'Se ha registrado los nuevos datos del deposito',
          });

          this.props.history.push('/');
        }
      })
      .catch(err => {
        console.log('Error en la creacion');
        console.log(err);
        errorService(err, {
          _id: this.props.match.params.id,
        });
        Modal.error({
          title: 'Error en la actualizacion del deposito',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Deposito</Breadcrumb.Item>
          <Breadcrumb.Item>Editar</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <FormDeposito
            onSubmit={this.actualizarDeposito}
            datos={this.state.deposito}
          />
        </Layout>
      </div>
    );
  }
}

export default withApollo(EditarDeposito);
